/* SVG_ICONS is the list of all available icons for use with Mat-Icon object */
/* Using a new SVG in the code requires adding the file to the following object */

export const SVG_ICONS: Map<string, string> = new Map ()
  .set('intosite.logo', 'IntositeLogo.svg')
  .set('intosite.logo.icon', 'IntositeLogoIcon.svg')
  .set('app.siemens-logo', 'app.siemens-logo.svg')
  .set('dropdown.expand-less', 'arrow.drop.up.svg')
  .set('dropdown.expand-more', 'arrow.drop.down.svg')
  .set('arrow.right', 'arrow.right.svg')
  .set('tree.open-group', 'tree.open-group.svg')

  .set('triangle.layer-add', 'triangle.layer-add.svg')

  .set('sites.load', 'sites_panel/sites.load.new.svg')
  .set('sites.edit', 'sites_panel/sites.edit.new.svg')

  .set('sites.search', 'sites_panel/sites.search.new.svg')

  .set('open.tour', 'tour_management/open.tour.svg')
  .set('copy.link', 'tour_management/copy.link.svg')

  .set('public.tour', 'tour_management/public.tour.svg')
  .set('import.obj', 'admin_panel/import.obj.new.svg')
  .set('mode.map', 'viewpoint_mode/map.viewpoints.mode.new.svg')
  .set('mode.facility', 'viewpoint_mode/facility.viewpoints.mode.new.svg')
  .set('mode.panoramic', 'viewpoint_mode/panoramic.viewpoints.mode.new.svg')
  .set('warning', 'dialogs/warning.message.indicator.svg')
  .set('app.datepicker', 'app.datepicker.svg')
  .set('app.arrow.left', 'app.arrow.left.svg')
  .set('app.arrow.right', 'app.arrow.right.svg')
  .set('app.open.date-picker', 'app.open.date-picker.svg')

  .set('app.delete', 'app.delete.svg')
  .set('app.trash', 'app.trash.svg')
  .set('app.edit', 'app.edit.svg')
  .set('app.import', 'app.import.svg')
  .set('app.export', 'app.export.svg')
  .set('app.approve', 'app.approve.svg')
  .set('app.reject', 'app.reject.svg')
  .set('app.add', 'app.add.svg')
  .set('app.refresh', 'app.refresh.svg')
  .set('app.preview', 'app.preview.svg')
  .set('app.person', 'app.person.svg')

  .set('panel.close', 'close/app.close.new.svg')
  .set('dialog.close', 'close/app.close.new.svg')

  .set('alert.info', 'dialogs/info.message.indicator.svg')
  .set('alert.warning', 'dialogs/warning.message.indicator.svg')
  .set('alert.err', 'dialogs/error.message.indicator.svg')
  .set('alert.err.outline', 'dialogs/error.message.outline.indicator.svg')

  .set('password.show', 'dialogs/password.show.svg')
  .set('password.hide', 'dialogs/password.hide.svg')

  .set('input-file.browse', 'ui_components/input-file.browse.svg')

  .set('help.tooltip', 'help.tooltip.svg')

  .set('add.placemark.submenu', 'app_right_controllers/add.placemark.submenu.new.svg')
  .set('models.submenu', 'app_right_controllers/menu.models.new.svg')
  .set('measure.action', 'app_right_controllers/measure.action.new.svg')
  .set('fit.action', 'app_right_controllers/fit.action.new.svg')
  .set('move.action', 'app_right_controllers/move.action.svg')
  .set('arrow.submenu', 'app_right_controllers/arrow.submenu.svg')
  .set('expand.menu', 'app_right_controllers/mat.expand.menu.svg')

  .set('sidebar.home', 'side_bar/home.new.svg')
  .set('sidebar.back', 'side_bar/back.new.svg')
  .set('sidebar.search', 'side_bar/search.new.svg')
  .set('sidebar.sites', 'side_bar/sites.new.svg')
  .set('sidebar.zones', 'side_bar/zones.new.svg')
  .set('sidebar.layers', 'side_bar/layers.new.svg')
  .set('sidebar.viewpoints', 'side_bar/viewpoints.new.svg')
  .set('sidebar.discussion', 'side_bar/discussion.new.svg')
  .set('sidebar.tour.placemarks', 'search_panel/indicatorPlacemarkResultLine16.svg')
  .set('panels.admin', 'side_bar/admin.new.svg')
  .set('panels.help', 'side_bar/help.new.svg')
  .set('panels.settings', 'side_bar/settings.new.svg')
  .set('panels.profile', 'side_bar/user.svg')
  .set('panels.profile.light', 'side_bar/user.light.svg')

  .set('facility.mode', 'app_right_controllers/cmdPlantView24.svg')
  .set('map.mode', 'app_right_controllers/cmdMapView24.svg')

  .set('template.management', 'admin_panel/template.management.svg')

  .set('documentation', 'help_panel/documentation.svg')
  .set('tutorials', 'help_panel/tutorials.svg')

  .set('signout', 'home_menu/menu.logout.new.svg')

  .set('cmd.remove', 'uploadEditLayoutDialog/cmdRemove16.svg')

  .set('edit.right.click.placemark', 'right_click_menu_placemark/edit.right.click.placemark.svg')
  .set('delete.right.click.placemark', 'right_click_menu_placemark/delete.right.click.placemark.svg')
  .set('history.right.click.placemark', 'right_click_menu_placemark/history.right.click.placemark.svg')
  .set('discussion.right.click.placemark', 'right_click_menu_placemark/discussion.right.click.placemark.svg')
  .set('print.right.click.placemark', 'right_click_menu_placemark/print.right.click.placemark.svg')
  .set('eventinfo.right.click.placemark','right_click_menu_placemark/eventinfo.right.click.placemark.svg')

  .set('like.discussion', 'discussion/like.discussion.svg')
  .set('comment.discussion', 'discussion/comment.discussion.svg')
  .set('reply.discussion', 'discussion/reply.svg')

  .set('placemarks.search.filter', 'search_panel/indicatorPlacemarkResultLine16.svg')
  .set('address.search.filter', 'search_panel/indicatorAddressResultLine16.svg')
  .set('panoramic.search.filter', 'search_panel/indicatorPanoramicResultLine16.svg')
  .set('viewpoints.search.filter', 'search_panel/indicatorFacilityViewPointLine16.svg')
  .set('model.search.filter', 'search_panel/indicatorFacilityModelLine16.svg')

  .set('placemarks.search.result', 'search_panel/indicatorPlacemarkResult16.svg')
  .set('address.search.result', 'search_panel/indicatorAddressResult16.svg')
  .set('panoramic.search.result', 'search_panel/indicatorPanoramicResult16.svg')
  .set('viewpoints.search.result', 'search_panel/indicatorFacilityViewPoint16.svg')
  .set('mapLocation.search.result', 'search_panel/indicatorMapViewPoint16.svg')
  .set('scanPlacemark.search.result', 'search_panel/indicatorScanPlacemarkResult16.svg')
  .set('model.search.result', 'search_panel/indicatorModelResult16.svg')

  .set('intositeBlack', 'login_page/IntositeLogoBlack.svg')
  .set('sie.logo', 'login_page/sieLogo.svg')
  .set('playTutorials', 'login_page/playTutorials.svg')
  .set('successIcon', 'login_page/requestSubmitted.svg')
  .set('chromeIcon', 'login_page/chrome.svg')
  .set('barchart', 'dynamic_pm/bar_chart.svg')
  .set('piechart', 'dynamic_pm/pie_chart.svg')
  .set('table', 'dynamic_pm/table.svg')
  .set('statustag', 'dynamic_pm/status_icon.svg')
  .set('pencilIcon', 'dynamic_pm/pencil_icon.svg')
  .set('showIcon', 'dynamic_pm/show_icon.svg')
  .set('hideIcon', 'dynamic_pm/hide_icon.svg')
  .set('addIcon', 'dynamic_pm/add_icon.svg')
  .set('removeIcon', 'dynamic_pm/remove_icon.svg')
  .set('connection', 'connection.svg')
  .set('copy', 'copy.svg')
  .set('scan.layer', 'layers-icons/scan_layer.svg')
  .set('pointCloudConf.link', 'point_cloud_conf_link.svg')
  .set('connect', 'connect.svg')
  .set('downloadIcon', 'download.svg')
  .set('operation.error', 'operation_status_board/status.failed.svg')
  .set('operation.success', 'operation_status_board/status.completed.svg')
  .set('operation.inprogress', 'operation_status_board/status.inprogress.svg')
  .set('status.link', 'operation_status_board/status.link.svg')
  .set('loader.circle.bg.light', 'loader.circle.bg.light.svg')
  .set('loader.circle.bg.dark', 'loader.circle.bg.dark.svg')
  .set('top.arrow', 'top.arrow.svg')


  .set('tour.prevStep', 'tour/images/tour.prevStep.svg')
  .set('tour.nextStep', 'tour/images/tour.nextStep.svg')

  .set('tour.ap.vol.mute', 'tour/audio-player/tour.ap.vol.mute.svg')
  .set('tour.ap.vol.low', 'tour/audio-player/tour.ap.vol.low.svg')
  .set('tour.ap.vol.high', 'tour/audio-player/tour.ap.vol.high.svg')

  .set('tour.ap.loading', 'tour/audio-player/tour.ap.loading.svg')
  .set('tour.ap.play', 'tour/audio-player/tour.ap.play.svg')
  .set('tour.ap.pause', 'tour/audio-player/tour.ap.pause.svg')

  .set('goto.last.page', 'pagination/goto.last.page.svg')
  .set('goto.first.page', 'pagination/goto.first.page.svg')
  .set('goto.next.page', 'pagination/goto.next.page.svg')
  .set('goto.previous.page', 'pagination/goto.previous.page.svg')
  
  .set('indicator.green.circle', 'indicator/indicator.green.circle.svg')
  .set('indicator.yellow.circle', 'indicator/indicator.yellow.circle.svg')
  .set('indicator.red.circle', 'indicator/indicator.red.circle.svg')
  .set('indicator.white.circle', 'indicator/indicator.white.circle.svg')

  .set('indicator.schedule.blue', 'indicator/indicator.schedule.blue.svg')
  .set('indicator.schedule.green', 'indicator/indicator.schedule.green.svg')
  .set('indicator.schedule.orange', 'indicator/indicator.schedule.orange.svg')

  .set('indicator.information.general', 'indicator/indicator_information_general.svg')
  .set('indicator.information.success', 'indicator/indicator_information_success.svg')
  .set('indicator.information.warning', 'indicator/indicator_information_warning.svg')
  .set('indicator.information.error', 'indicator/indicator_information_error.svg')


  .set('app.site', 'common_icons/site.svg')
  .set('app.zone', 'common_icons/zone.svg')
  .set('app.schedule', 'common_icons/schedule.svg')
  .set('app.copy', 'common_icons/copy.svg')
  .set('app.link', 'common_icons/link.svg')
  .set('app.unlink', 'common_icons/unlink.svg')
  .set('app.user.role', 'common_icons/role.svg')
  .set('app.user.role.default', 'common_icons/role_default.svg')
  .set('app.access.controls', 'common_icons/access_controls.svg')
  .set('app.select.all', 'common_icons/select_all.svg')
  .set('app.deselect.all', 'common_icons/deselect_all.svg')

  .set('app.show.all', 'common_icons/showAll.svg')
  .set('app.save.edit', 'common_icons/saveEdit.svg')
  .set('app.cancel.edit', 'common_icons/cancelEdit.svg')
  .set('app.collapse.all', 'common_icons/collapseAll.svg')
  .set('app.expand.all', 'common_icons/expandAll.svg')
  .set('app.mass.assign', 'common_icons/massAssign.svg')
  .set('app.expand.dialog', 'common_icons/expand_dialog.svg')
  .set('app.collapse.dialog', 'common_icons/collapse_dialog.svg')
  .set('app.filter', 'common_icons/filter.svg')
;
